import { PAGE_TYPE } from '@api/pages/constants';

export default Object.values(PAGE_TYPE);
